"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheCalmSanctuary() {
  const headingReveal = useRevealOnScroll({
    threshold: 0.2
  });
  const textReveal = useRevealOnScroll({
    threshold: 0.2
  });
  const imageReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223413" id="seo-russia-e-posizionamento-yandex-la-guida-strategica-b2b" className="bg-background text-foreground relative overflow-hidden min-h-screen flex items-center">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591142/img/eurasia_data_mesh_3d_earth.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591142/img/eurasia_data_mesh_3d_earth.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591142/img/eurasia_data_mesh_3d_earth.png-wvc-sizes" alt="Eurasia Data Mesh Background" className="w-full h-full object-cover" loading="lazy" />
      </div>
      
      {}
      <div className="absolute inset-0 bg-black/85 z-0" />

      <div className="mx-auto w-full max-w-[1600px] px-6 sm:px-8 lg:px-16 py-24 lg:py-0 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 lg:gap-24 items-center">
          
          <div className="lg:col-span-3 flex flex-col gap-10 lg:pr-12 xl:pr-24 z-10">
            <h1 ref={headingReveal.ref} className={`font-default font-bold text-5xl sm:text-6xl md:text-7xl lg:text-[5rem] xl:text-[6rem] leading-[1.05] tracking-tighter text-foreground transition-all duration-[1200ms] ease-out z-10 ${headingReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              SEO Russia e <br className="hidden sm:block" /> 
              <span className="bg-gradient-to-r from-primary to-primary/80 bg-clip-text text-transparent">Posizionamento Yandex</span>
            </h1>
            
            <div ref={textReveal.ref} className={`flex flex-col gap-10 transition-all duration-[1200ms] delay-300 ease-out z-10 ${textReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              <div className="flex flex-col gap-4">
                <div className="h-px w-24 bg-secondary" />
                <p className="font-mono text-xl md:text-2xl text-muted-foreground max-w-lg leading-relaxed uppercase tracking-wider">
                  Infrastruttura Nativa. Conformità FZ-152. Lead Generation B2B.
                </p>
              </div>
              
              <div>
                <Link to="/ContactPage">
                  <Button variant="outline" className="rounded-none border-primary bg-primary text-primary-foreground hover:bg-transparent hover:text-primary transition-all duration-500 font-default font-bold tracking-widest uppercase text-sm px-12 py-8 h-auto shadow-lg shadow-primary/20 z-10">
                    Inizia Analisi
                    <span className="ml-2 animate-bounce">↓</span>
                  </Button>
                </Link>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2 h-[65vh] lg:h-[90vh] w-full relative overflow-hidden z-10">
            <div ref={imageReveal.ref} className="w-full h-full relative overflow-hidden bg-muted/10">
              <img src="https://seorussia.it/wp-content/uploads/2026/04/seo-yandex-posizionamento-b2b-russia.webp" data-wvc-srcset="/img/seo-yandex-posizionamento-b2b-russia.webp-wvc-srcset" data-wvc-sizes="/img/seo-yandex-posizionamento-b2b-russia.webp-wvc-sizes" alt="SEO Yandex B2B Russia positioning" className={`object-contain w-full h-full origin-center transition-transform duration-[3000ms] ease-out ${imageReveal.isVisible ? "scale-100" : "scale-125"}`} loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent pointer-events-none"></div>
              <div className="absolute inset-0 bg-background/10 lg:hidden pointer-events-none"></div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}